import { createAction } from "@reduxjs/toolkit";
import type { BatchStudent } from "@shared-kernel/application/ports/educational-advisor/educational-advisor-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const retrieveEducationalAdvisorStudents = createApiThunk<BatchStudent[], void>(
  "educationalAdvisor/retrieveEducationalAdvisorStudents",
  async (_, { extra: { educationalAdvisorRepository } }) => {
    return educationalAdvisorRepository!.getStudents();
  },
);

export const resetRetrieveEducationalAdvisorStudents = createAction("educationalAdvisor/resetRetrieveEducationalAdvisorStudents");
